// extracted by mini-css-extract-plugin
export default {"item":"ColorItem_item__+3gLD","label":"ColorItem_label__R1njf","itemText":"ColorItem_itemText__FNdfi","checkboxSpan":"ColorItem_checkboxSpan__P5P0G","color":"ColorItem_color__43cHl"};